module.exports = __webpack_public_path__ + "media/images/covid/icons/sheet-87013155ed4a06243866e458143eb540.svg";